export const setBatchEditData = (gridEditData, setGridEditData, args) => {
  if (args.action === 'edit') {
    const element = args.data;
    const newEditData = gridEditData.map(obj => {
      if (obj.id === element.id) {
        return { ...element };
      }
      return obj;
    });
    setGridEditData(newEditData);
  }
};